export default [
  {
    title: 'Ballad',
    description: 'Generates ideas for ballads for you to write',
    key: 'ballad',
    generator: 'story-builder',
    modules: [
      'ballad/ballad.yaml',
      'ballad/hair.yaml',
      'ballad/height.yaml',
      'ballad/clothing.yaml'
    ],
    display: {
      title: 'title',
      description: 'body',
      sections: [
        {
          heading: 'Description',
          generate: 'physicalDescription'
        }
      ]
    }
  }, {
    title: 'Skit',
    description: 'Generates setups for a skit',
    key: 'skit',
    generator: 'story-builder',
    modules: [
      'skit/skit.yaml'
    ],
    display: {
      title: 'title',
      description: 'skit',
      sections: [
      ]
    }
  }, {
    title: 'Acting & Performing Tips',
    description: 'Good and excellent pieces of acting and performing advice',
    key: 'acting',
    generator: 'markov',
    modules: [
      'acting/acting.yaml'
    ],
    display: {
      title: 'title',
      description: 'advice',
      sections: [
      ]
    }
  }
]
